/**
 * @generated SignedSource<<59714e33aa12a68fd1f60e86fe0999eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type magazinesStyleFashionCarouselContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "magazinesStyleFashionCarouselContentItemContent";
};
export type magazinesStyleFashionCarouselContentItemContent$key = {
  readonly " $data"?: magazinesStyleFashionCarouselContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"magazinesStyleFashionCarouselContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "magazinesStyleFashionCarouselContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "4bee8c83c5af599b9b71c58a7c310edc";

export default node;
